import { FilterTypes, OfferType, RegionName, Subregion } from "Types";
import routes from "./routes";

export enum OfferTypeNames {
    flats = "Byty",
    houses = "Domy a vily",
    lands = "Pozemky",
    commercial = "Komerční",
    housesToRent = "Nájemní domy",
    other = "Ostatní",
}

export const PropertyTypesValues = {
    [FilterTypes.flats]: {
        label: OfferTypeNames.flats,
        path: routes.flats,
    },
    [FilterTypes.houses]: {
        label: OfferTypeNames.houses,
        path: routes.houses,
    },
    [FilterTypes.lands]: {
        label: OfferTypeNames.lands,
        path: routes.lands,
    },
    [FilterTypes.commercials]: {
        label: OfferTypeNames.commercial,
        path: routes.commercial,
    },
    [FilterTypes.others]: {
        label: OfferTypeNames.other,
        path: routes.other,
    },
};

export const availableOfferTypes = [
    { id: OfferType.all, value: "Vše", urlValue: null },
    { id: OfferType.sell, value: "Prodej", urlValue: "prodej" },
    { id: OfferType.rent, value: "Pronájem", urlValue: "pronajem" },
];

export const availableDispositions = [
    { id: 1, value: "garsoniéra", urlValue: "garsoniera" },
    { id: 2, value: "1+kk", urlValue: "1+kk" },
    { id: 9, value: "1+1", urlValue: "1+1" },
    { id: 3, value: "2+kk", urlValue: "2+kk" },
    { id: 10, value: "2+1", urlValue: "2+1" },
    { id: 4, value: "3+kk", urlValue: "3+kk" },
    { id: 11, value: "3+1", urlValue: "3+1" },
    { id: 5, value: "4+kk", urlValue: "4+kk" },
    { id: 12, value: "4+1", urlValue: "4+1" },
    { id: 6, value: "5+kk", urlValue: "5+kk" },
    { id: 13, value: "5+1", urlValue: "5+1" },
    { id: 7, value: "6+kk", urlValue: "6+kk" },
    { id: 14, value: "6+1", urlValue: "6+1" },
    { id: 8, value: "7+kk", urlValue: "7+kk" },
    { id: 15, value: "7+1", urlValue: "7+1" },
    { id: 16, value: "atypický", urlValue: "atypicky" },
    { id: 17, value: "jiný", urlValue: "jiny" },
];

export const availablePropertiesConditions = [
    { id: 1, value: "Velmi dobrý", urlValue: "" },
    { id: 2, value: "Dobrý", urlValue: "" },
    { id: 3, value: "Špatný", urlValue: "" },
    { id: 4, value: "Ve výstavbě", urlValue: "" },
    { id: 5, value: "Developerské projekty", urlValue: "" },
    { id: 6, value: "Novostavba", urlValue: "" },
    { id: 7, value: "K demolici", urlValue: "" },
    { id: 8, value: "Před rekonstrukcí", urlValue: "" },
    { id: 9, value: "Po rekonstrukci", urlValue: "" },
];

export const availableOwnerships = [
    { id: 1, value: "Osobní", urlValue: "osobni" },
    { id: 2, value: "Družstevní", urlValue: "druzstevni" },
    { id: 3, value: "Ostatní", urlValue: "ostatni" },
];

export const availableBuildingTypes = [
    { id: 1, value: "Dřevěná", urlValue: "drevena" },
    { id: 2, value: "Cihlová", urlValue: "cihlova" },
    { id: 3, value: "Kamenná", urlValue: "kamenna" },
    { id: 4, value: "Montovaná", urlValue: "montovana" },
    { id: 5, value: "Panelová", urlValue: "panelova" },
    { id: 6, value: "Skeletová", urlValue: "skeletova" },
    { id: 7, value: "Smíšená", urlValue: "smisena" },
];

export const availableLandTypes = [
    { id: 2, value: "Bydlení", urlValue: "stavebni-bydleni" },
    { id: 1, value: "Komerční", urlValue: "komercni-vystavba" },
    { id: 3, value: "Pole", urlValue: "zemedelsky" },
    { id: 5, value: "Louky", urlValue: "louka" },
    { id: 4, value: "Lesy", urlValue: "les" },
    { id: 6, value: "Zahrady", urlValue: "zahrada" },
    { id: 7, value: "Ostatní", urlValue: "ostatni" },
];

export const availableCommercialTypes = [
    { id: 1, value: "Kanceláře", urlValue: "kancelare" },
    { id: 3, value: "Sklady", urlValue: "skladovaci" },
    { id: 5, value: "Výroba", urlValue: "vyrobni" },
    { id: 2, value: "Obchodní", urlValue: "obchodni" },
    { id: 4, value: "Jiné", urlValue: "jine" },
];

export const availableHospitalityTypes = [
    { id: 1, value: "Hotel", urlValue: "hotel" },
    { id: 2, value: "Penzion", urlValue: "penzion" },
    { id: 3, value: "Restaurace", urlValue: "restaurace" },
];

export const availableOtherTypes = [
    { id: 10, value: "Chaty a chalupy", urlValue: "chaty-chalupy" },
    { id: 11, value: "Malé objekty a garáže", urlValue: "male-objekty-garaze" },
    { id: 5, value: "Historické objekty", urlValue: "historicke-objekty" },
    { id: 1, value: "Zemědělské objekty", urlValue: "zemedelske-objekty" },
];

// Regions
// Praha
export const availableSubregion: { [key in RegionName]: Subregion[] } = {
    "jihocesky-kraj": [
        { id: 3301, value: "České Budějovice" },
        { id: 3302, value: "Český Krumlov" },
        { id: 3303, value: "Jindřichův Hradec" },
        { id: 3305, value: "Písek" },
        { id: 3306, value: "Prachatice" },
        { id: 3307, value: "Strakonice" },
    ],
    "jihomoravsky-kraj": [
        { id: 3701, value: "Blansko" },
        { id: 3702, value: "Brno-město" },
        { id: 3703, value: "Brno-venkov" },
        { id: 3704, value: "Břeclav" },
        { id: 3706, value: "Hodonín" },
        { id: 3712, value: "Vyškov" },
        { id: 3713, value: "Znojmo" },
    ],
    "karlovarsky-kraj": [
        { id: 3402, value: "Cheb" },
        { id: 3403, value: "Karlovy Vary" },
        { id: 3409, value: "Sokolov" },
    ],
    "kralovehradecky-kraj": [
        { id: 3602, value: "Hradec Králové" },
        { id: 3604, value: "Jičín" },
        { id: 3605, value: "Náchod" },
        { id: 3607, value: "Rychnov nad Kněžnou" },
        { id: 3610, value: "Trutnov" },
    ],
    "liberecky-kraj": [
        { id: 3501, value: "Česká Lípa" },
        { id: 3504, value: "Jablonec nad Nisou" },
        { id: 3505, value: "Liberec" },
        { id: 3608, value: "Semily" },
    ],
    "moravskoslezsky-kraj": [
        { id: 3801, value: "Bruntál" },
        { id: 3802, value: "Frýdek-Místek" },
        { id: 3803, value: "Karviná" },
        { id: 3804, value: "Nový Jičín" },
        { id: 3806, value: "Opava" },
        { id: 3807, value: "Ostrava-město" },
    ],
    "olomoucky-kraj": [
        { id: 3709, value: "Prostějov" },
        { id: 3805, value: "Olomouc" },
        { id: 3808, value: "Přerov" },
        { id: 3809, value: "Šumperk" },
        { id: 3811, value: "Jeseník" },
    ],
    "pardubicky-kraj": [
        { id: 3603, value: "Chrudim" },
        { id: 3606, value: "Pardubice" },
        { id: 3609, value: "Svitavy" },
        { id: 3611, value: "Ústí nad Orlicí" },
    ],
    "plzensky-kraj": [
        { id: 3401, value: "Domažlice" },
        { id: 3404, value: "Klatovy" },
        { id: 3405, value: "Plzeň-město" },
        { id: 3406, value: "Plzeň-jih" },
        { id: 3407, value: "Plzeň-sever" },
        { id: 3408, value: "Rokycany" },
        { id: 3410, value: "Tachov" },
    ],
    "stredocesky-kraj": [
        { id: 3201, value: "Benešov" },
        { id: 3202, value: "Beroun" },
        { id: 3203, value: "Kladno" },
        { id: 3204, value: "Kolín" },
        { id: 3205, value: "Kutná Hora" },
        { id: 3206, value: "Mělník" },
        { id: 3207, value: "Mladá Boleslav" },
        { id: 3208, value: "Nymburk" },
        { id: 3209, value: "Praha-východ" },
        { id: 3210, value: "Praha-západ" },
        { id: 3211, value: "Příbram" },
        { id: 3212, value: "Rakovník" },
    ],
    "ustecky-kraj": [
        { id: 3502, value: "Děčín" },
        { id: 3503, value: "Chomutov" },
        { id: 3506, value: "Litoměřice" },
        { id: 3507, value: "Louny" },
        { id: 3508, value: "Most" },
        { id: 3509, value: "Teplice" },
        { id: 3510, value: "Ústí nad Labem" },
    ],
    "zlinsky-kraj": [
        { id: 3705, value: "Zlín" },
        { id: 3708, value: "Kroměříž" },
        { id: 3711, value: "Uherské Hradiště" },
        { id: 3810, value: "Vsetín" },
    ],
    vysocina: [
        { id: 3304, value: "Pelhřimov" },
        { id: 3601, value: "Havlíčkův Brod" },
        { id: 3707, value: "Jihlava" },
        { id: 3710, value: "Třebíč" },
        { id: 3714, value: "Žďár nad Sázavou" },
    ],
    praha: [
        { id: 500054, value: "Praha 1" },
        { id: 500089, value: "Praha 2" },
        { id: 500097, value: "Praha 3" },
        { id: 500119, value: "Praha 4" },
        { id: 500143, value: "Praha 5" },
        { id: 500178, value: "Praha 6" },
        { id: 500186, value: "Praha 7" },
        { id: 500208, value: "Praha 8" },
        { id: 500216, value: "Praha 9" },
        { id: 500224, value: "Praha 10" },
    ],
};
